/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block}\n/*# sourceMappingURL=back-button.component.css.map*/"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/back-button/back-button.component.css.shim.ngstyle.js.pre-build-optimizer.js